import React from "react";
import { useTranslation } from "react-i18next";
import { addConfigurationStateTexts } from "models/configuration_state.enum";
import { ErrorHandlerComponent } from "../error_handling/error_handler.component";
import { ContentComponent } from "./content.component";
import { FooterComponent } from "./footer.component";
import { HeaderComponent } from "./header.component";
import { LayoutAreaRoot } from "./layoutarea.style";

/** MCE frame for focused views: header, content and footer without menu or breadcrumbs. */
export const FocusedLayoutArea = ({ children }: { children: React.ReactNode }) => {
  const { t } = useTranslation();
  addConfigurationStateTexts(t);

  return (
    <LayoutAreaRoot>
      <HeaderComponent />
      <ContentComponent>
        <ErrorHandlerComponent>{children}</ErrorHandlerComponent>
      </ContentComponent>
      <FooterComponent />
    </LayoutAreaRoot>
  );
};
